if (!customElements.get('sticky-reasons')) {
  class StickyReasons extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('[data-sr-item]'));
      if (!this.items.length) return;

      this.offset = parseFloat(this.dataset.offset) || 0;
      this.pinLine = this.offset;
      this.frame = null;
      this.running = false;

      this.onScroll = this.onScroll.bind(this);
      this.onResize = this.onResize.bind(this);
      this.onBreakpoint = this.onBreakpoint.bind(this);

      this.desktopQuery = window.matchMedia('(min-width: 1000px)');
      this.desktopQuery.addEventListener('change', this.onBreakpoint);
      window.addEventListener('resize', this.onResize);
      document.addEventListener('on:debounced-resize', this.onResize);

      this.onBreakpoint();
    }

    disconnectedCallback() {
      this.stop();
      window.removeEventListener('resize', this.onResize);
      document.removeEventListener('on:debounced-resize', this.onResize);
      if (this.desktopQuery) this.desktopQuery.removeEventListener('change', this.onBreakpoint);
    }

    onBreakpoint() {
      if (this.desktopQuery.matches) {
        this.start();
      } else {
        this.stop();
      }
    }

    start() {
      if (this.running) return;
      this.running = true;

      window.addEventListener('scroll', this.onScroll, { passive: true });

      if (!this.cardObserver) {
        this.cardObserver = new ResizeObserver(() => this.update());
      }

      this.cardObserver.observe(this.items[this.items.length - 1]);

      this.measure();
      this.update();
    }

    stop() {
      if (!this.running) return;
      this.running = false;

      window.removeEventListener('scroll', this.onScroll);

      if (this.cardObserver) this.cardObserver.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = null;

      this.classList.remove('is-complete');
      this.style.removeProperty('--sr-sticky-top');
      this.style.removeProperty('--sr-stop-offset');
      this.stopOffset = null;
    }

    measure() {
      const header = document.querySelector('.section-header');
      const headerHeight = header && getComputedStyle(header).position === 'sticky' ? header.offsetHeight : 0;

      this.pinLine = headerHeight + this.offset;
      this.style.setProperty('--sr-sticky-top', `${this.pinLine}px`);
    }

    onResize() {
      this.onBreakpoint();
      if (!this.running) return;
      this.measure();
      this.update();
    }

    onScroll() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        this.update();
      });
    }

    update() {
      const last = this.items[this.items.length - 1];
      const rect = last.getBoundingClientRect();
      const stopOffset = Math.round(rect.height / 2);

      if (stopOffset !== this.stopOffset) {
        this.stopOffset = stopOffset;
        this.style.setProperty('--sr-stop-offset', `${stopOffset}px`);
      }

      this.classList.toggle('is-complete', rect.bottom <= window.innerHeight + 1);
    }

    revealItem(item) {
      const top = window.scrollY + item.getBoundingClientRect().top - this.pinLine;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  }

  customElements.define('sticky-reasons', StickyReasons);
}

document.addEventListener('shopify:block:select', (evt) => {
  const section = evt.target.closest('sticky-reasons');

  if (!section || typeof section.revealItem !== 'function') return;

  const item = evt.target.closest('[data-sr-item]');
  
  if (item) section.revealItem(item);
});
